






import { Component, Vue } from 'vue-property-decorator'
import AppLayout from './components/layout/AppLayout.vue'


@Component({
    components: {
        AppLayout
    }
})
export default class App extends Vue {
    loading = false
}
